// @flow
import type { FluxStandardAction } from 'modules/helper';
import { CareerActionTypes } from './actionTypes';
import type { JobPost } from 'types/careers';

export type CareerState = {
  jobPosts: Array<JobPost> | null,
  specificJobPost: Object<JobPost> | null,
  loading: {
    jobPosts: boolean,
    specificJobPost: boolean,
  },
  error: {
    jobPosts: string | null,
    specificJobPost: string | null,
  },
};

const initialState: CareerState = {
  jobPosts: null,
  specificJobPost: null,
  loading: {
    jobPosts: false,
    specificJobPost: false,
  },
  error: {
    jobPosts: false,
    specificJobPost: false,
  },
};

export const CareerReducer = (
  state: CareerState = initialState,
  action: FluxStandardAction
) => {
  const { type, payload, error } = action;

  switch (type) {
    // Job Posts
    case CareerActionTypes.CAREERS.FETCH:
      return {
        ...state,
        loading: { ...state.loading, jobPosts: true },
        error: { ...state.error, jobPosts: null },
      };
    case CareerActionTypes.CAREERS.SUCCESS:
      return {
        ...state,
        jobPosts: payload,
        loading: { ...state.loading, jobPosts: false },
      };
    case CareerActionTypes.CAREERS.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, jobPosts: false },
        error: { ...state.error, jobPosts: error },
      };

    //  SpecificJobPosts
    case CareerActionTypes.SPECIFICJOB.FETCH:
      return {
        ...state,
        loading: { ...state.loading, specificJobPost: true },
        error: { ...state.error, specificJobPost: null },
      };
    case CareerActionTypes.SPECIFICJOB.SUCCESS:
      return {
        ...state,
        specificJobPost: payload[0],
        loading: { ...state.loading, specificJobPost: false },
      };
    case CareerActionTypes.SPECIFICJOB.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, specificJobPost: false },
        error: { ...state.error, specificJobPost: error },
      };

    default:
      return state;
  }
};
